export function CrowdFavoriteIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="18" cy="18" r="6" />
      <circle cx="30" cy="18" r="6" />
      <path d="M8 36c0-5 4-10 10-10" />
      <path d="M30 26c6 0 10 5 10 10" />
      <circle cx="24" cy="30" r="6" />
      <path d="M14 42c0-5 4-10 10-10s10 5 10 10" />
    </svg>
  );
}
